import { render, staticRenderFns } from "./HelpTOCItem.vue?vue&type=template&id=08f7dbf6&"
import script from "./HelpTOCItem.vue?vue&type=script&lang=js&"
export * from "./HelpTOCItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports